module.exports = __webpack_public_path__ + "media/BG04.1c00e666.mp4";